import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import * as paths from 'src/routes/paths'
import GlobalStyle from './components/styles/GlobalStyles'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

import PrivateRoutes from './utils/PrivateRoutes'
import routes from './routes'
import { Loader } from './components/sharedComponents/Loader'
import VirgilioContainer from './container/VirgilioContainer/Virgilio'

const LayoutDashboard = lazy(() => import('./components/Dashboard/index'))
const BussninesUnitContainer = lazy(() =>
  import('src/container/HomeDashboard/BussninesUnitContainer'),
)

const App = () => (
  <>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    <Suspense fallback={null}>
      <GlobalStyle />
      <Loader />
      <Router>
        <Switch>
          {routes.singleRoutes.map((route) => (
            <Route
              key={route.path}
              exact={route.exact}
              path={route.path}
              component={route.component}
            />
          ))}
          <LayoutDashboard>
            <PrivateRoutes
              exact
              path={paths.HOME}
              component={BussninesUnitContainer}
            />
            <PrivateRoutes
              exact
              path="/virgilio"
              component={VirgilioContainer}
            />

            {routes.sliderRouter.map(({ route }) =>
              route.map((item) => (
                <>
                  {item.subItems ? (
                    item.subItems.map((subItem) => (
                      <PrivateRoutes
                        key={subItem.path}
                        exact={subItem.exact}
                        path={subItem.path}
                        component={subItem.component}
                      />
                    ))
                  ) : (
                    <PrivateRoutes
                      key={item.path}
                      exact={item.exact}
                      path={item.path}
                      component={item.component}
                    />
                  )}
                </>
              )),
            )}
          </LayoutDashboard>
        </Switch>
      </Router>
    </Suspense>
  </>
)

export default App
